import { z } from 'zod'
import { oc } from '@orpc/contract'
import { pageRequestSchema, pageSchema } from '../../utils/page.contract'
import { taskRunSchema } from './tasks-shared.contract'

/** Newest first. `slug` = '-' lists runs across ALL tasks. `log` is always null here. */
export const listTaskRuns = oc
  .route({ method: 'GET', path: '/v2/tasks/{slug}/runs' })
  .input(pageRequestSchema.extend({ slug: z.string().min(1) }))
  .output(z.object({ page: pageSchema, data: z.array(taskRunSchema) }))
